import { DownloadOutlined } from '@ant-design/icons';
import pluralize from 'pluralize';
import { Button } from 'components/ui';
import { ImportResult } from '../../types';
import { ErrorText, SuccessText } from '../common.style';

type ErrorStateProps = { importResult: ImportResult | undefined; importedFileName: string };

export const ErrorState: React.FunctionComponent<ErrorStateProps> = ({
  importResult,
  importedFileName,
}) => {
  const {
    createdDamageCount,
    duplicateDamageCount,
    duplicateDamageCsv,
    invalidDamageCount,
    invalidDamageCsv,
  } = importResult ?? {};

  return (
    <>
      <SuccessText>
        {pluralize('damage', createdDamageCount, true)} successfully created.
      </SuccessText>
      {!!duplicateDamageCount && duplicateDamageCsv && (
        <>
          <ErrorText fontWeight="bold" mb={2}>
            {pluralize('row', duplicateDamageCount, true)} in {importedFileName} contained duplicate
            damage information.
          </ErrorText>
          <ErrorText>
            Please use the button below to download the duplicates file. Duplicates may not be
            reuploaded.
          </ErrorText>
          <Button icon={<DownloadOutlined />} href={duplicateDamageCsv} target="_blank">
            Download Duplicate File
          </Button>
        </>
      )}
      {!!invalidDamageCount && invalidDamageCsv && (
        <>
          <ErrorText fontWeight="bold" mb={2}>
            {pluralize('row', invalidDamageCount, true)} in {importedFileName} contained invalid or
            incomplete data.
          </ErrorText>
          <ErrorText>
            Please use the button below to download the error file. Complete the missing data and
            upload again. The following fields are required: <b>Photo File Name and Coordinates</b>.
            Coordinates must be in the format <b>[X1,Y1],[X2,Y2],[X3,Y3],[X4,Y4]</b>.
          </ErrorText>
          <Button icon={<DownloadOutlined />} href={invalidDamageCsv} target="_blank">
            Download Error File
          </Button>
        </>
      )}
    </>
  );
};
